import React from 'react';

import { TotemIconId } from '@meilleurtaux/mtp-uikit-core';
import { MtxIcon } from '@meilleurtaux/mtp-uikit-react';

import styles from './styles.module.css';

interface LinkCardProps {
  title: string;
  subtitle: string;
  icon: TotemIconId;
  onClick: () => void;
}

export const LinkCard: React.FC<LinkCardProps> = ({ title, subtitle, icon, onClick }) => {
  return (
    <button type="button" className={styles.linkCard} onClick={onClick}>
      <div className={styles.linkCardContent}>
        <div className={styles.iconWrapper}>
          <MtxIcon name={icon} size={24} />
        </div>
        <div className={styles.linkCardTitles}>
          <span className={styles.linkCardTitle}>{title}</span>
          <span className={styles.linkCardSubtitle}>{subtitle}</span>
        </div>
      </div>
      <MtxIcon className={styles.chevron} name="chevron-right-big" size={24} />
    </button>
  );
};
